//------------------------------------------------------------------------------
// メニュー
//------------------------------------------------------------------------------
import React from 'react';

/**
 * メニュー項目
 */
export default class MenuItem {

  /**
   * 項目ID
   * - メニュー項目の識別子
   * - 権限ID(画面ID)と一致
   */
  id: string;

  /**
   * 項目キー
   * - メニュー階層を反映した識別子
   * - 親項目のキーとIDを連結したもの
   */
  key: string;

  /** 項目名 */
  label: string;

  /** 遷移先画面パス */
  link: string | null;

  /** 項目アイコン */
  icon: React.ReactNode | null;

  /**
   * コンストラクタ
   *
   * @param id 項目ID
   * @param key 項目キー
   * @param label 項目名
   * @param link 遷移先画面パス
   * @param icon 項目アイコン
   */
  constructor(
      id: string,
      key: string,
      label: string,
      link?: string,
      icon?: React.ReactNode) {
    this.id = id;
    this.key = key;
    this.label = label;
    this.link = link ?? null;
    this.icon = icon ?? null;
  }

  /**
   * 子項目一覧
   */
  children(): MenuItem[] {
    return [];
  }
};
